import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

export default function useLoginValidationSchema() {
  const { getMessage } = useMessageSource();

  const validateEmail = Yup.string()
    .email(getMessage("Validation.message-email"))
    .required(getMessage("Validation.message-required"));

  const validatePassword = Yup.string().required(
    getMessage("Validation.message-required"),
  );

  return Yup.object().shape({
    password: validatePassword,
    emailBusiness: validateEmail,
  });
}
